export class Profile {
  id: number;
  name: string = 'Administrator';
  glyph: string;
  link: string;
  details: Array<any> = [];
}
